import { render } from "./QuoteCustomerDetails.vue?vue&type=template&id=ecc37476&scoped=true&ts=true"
import script from "./QuoteCustomerDetails.vue?vue&type=script&lang=ts"
export * from "./QuoteCustomerDetails.vue?vue&type=script&lang=ts"

import "./QuoteCustomerDetails.vue?vue&type=style&index=0&id=ecc37476&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc37476"]])

export default __exports__